import { SVGProps } from 'react';
const GoogleLogoSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.48918 13.8777L6.86263 16.2167L4.57258 16.2651C3.8882 14.9957 3.5 13.5434 3.5 12C3.5 10.5076 3.86295 9.10023 4.50631 7.86101H4.5068L6.54559 8.23479L7.4387 10.2613C7.25177 10.8063 7.14989 11.3913 7.14989 12C7.14996 12.6607 7.26963 13.2937 7.48918 13.8777Z'
      fill='#FBBB00'
    />
    <path
      d='M21.3427 10.3187C21.4461 10.8631 21.5 11.4253 21.5 12C21.5 12.6443 21.4323 13.2728 21.3032 13.8791C20.8651 15.9422 19.7203 17.7437 18.1344 19.0185L18.1339 19.018L15.566 18.887L15.2025 16.6182C16.2548 16.001 17.0772 15.0353 17.5104 13.8791H12.6979V10.3187H17.5806H21.3427Z'
      fill='#518EF8'
    />
    <path
      d='M18.1339 19.018L18.1344 19.0185C16.5921 20.2583 14.6328 21 12.5 21C9.0726 21 6.09272 19.0843 4.5726 16.2651L7.4892 13.8777C8.24924 15.9061 10.206 17.3501 12.5 17.3501C13.486 17.3501 14.4098 17.0835 15.2025 16.6182L18.1339 19.018Z'
      fill='#28B446'
    />
    <path
      d='M18.2446 5.07197L15.329 7.45894C14.5086 6.94615 13.5389 6.64992 12.4999 6.64992C10.154 6.64992 8.16063 8.16013 7.43866 10.2613L4.50673 7.86098H4.50624C6.00411 4.97307 9.02157 3 12.4999 3C14.6837 3 16.6859 3.77787 18.2446 5.07197Z'
      fill='#F14336'
    />
  </svg>
);
export default GoogleLogoSvg;
